export const groupBy = (list: any, keyGetter: any) => {
  const map = new Map();
  list.forEach((item: any) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

export function getProp(obj: any, key: string) {
  return obj && obj[key];
}

export function findInObjectByKey(obj: {}, key: string, value: string) {
  let result = undefined;
  Object.keys(obj).forEach((k) => {
    // @ts-ignore
    if (obj[k][key] === value) result = obj[k];
  });
  return result;
}
